import React, { useState } from 'react';
import { Toolbar, Typography, TextField } from '@mui/material';

function DashboardPageToolBar({ pageTitle, data2, setData, setHighlightQuery }) {
    const [searchText, setSearchText] = useState("");

    const handleChangeSearchText = (text) => {
        if (text !== "") {
            const filterData = data2.filter(
                (item) =>
                    item.decisionNo === Number(text) ||
                    (item.decision && item.decision.toLowerCase().includes(text.toLowerCase())) ||
                    (item.agenda && item.agenda.toLowerCase().includes(text.toLowerCase()))
            );
            setSearchText(text);
            setHighlightQuery(text);
            setData(filterData);
        } else {
            setSearchText(text);
            setHighlightQuery(text);
            setData(data2);
        }
    };

    return (
        <Toolbar sx={{ width: '100%', justifyContent: 'space-between', marginBottom: 2 }}>
            <Typography variant="h6">{pageTitle}</Typography>
            <TextField
                value={searchText}
                onChange={(e) => handleChangeSearchText(e.target.value)}
                margin="dense"
                label="Arama Yap"
                style={{ width: "390px", background: 'white' }}
                placeholder="Bilgi"
                size='small'
            />
        </Toolbar>
    );
}

export default DashboardPageToolBar;
